import { useFieldInfo, useTsController } from "@ts-react/form";
import { useId } from "react";
import { Fieldset, type SizeTokens, XStack } from "tamagui";
import { z } from "zod";
import { BentoInput } from "../bento/inputParts";
import { Label } from "../Typography";
import { FormError } from "./FormError";
export const AddressSchema = z.object({
  street: z.string().min(4),
  zipCode: z.string().regex(/\d{5}/, "ZIP code should contain only 5 integers")
});
export const AddressField = ({
  size
}: {
  size?: SizeTokens;
}) => {
  const {
    field,
    error,
    formState: {
      isSubmitting
    }
  } = useTsController<z.infer<typeof AddressSchema>>();
  const {
    label
  } = useFieldInfo();
  const id = useId();
  const disabled = isSubmitting;
  return <Fieldset gap="$1" data-sentry-element="Fieldset" data-sentry-component="AddressField" data-sentry-source-file="AddressField.tsx">
      <Label size="$3" pb="$1" pl={0} data-sentry-element="Label" data-sentry-source-file="AddressField.tsx">
        {label}
      </Label>

      <XStack $sm={{
      flexDirection: "column"
    }} $gtSm={{
      flexWrap: "wrap"
    }} gap="$2" data-sentry-element="XStack" data-sentry-source-file="AddressField.tsx">
        <Fieldset data-sentry-element="Fieldset" data-sentry-source-file="AddressField.tsx">
          <BentoInput theme={error?.street ? "red_alt2" : "granted"} size={size || "$4"} data-sentry-element="BentoInput" data-sentry-source-file="AddressField.tsx">
            {label ? <BentoInput.Label htmlFor={`${id}-street`}>
                Street Address
              </BentoInput.Label> : null}
            <BentoInput.Box disabled={disabled} data-sentry-element="BentoInput.Box" data-sentry-source-file="AddressField.tsx">
              <BentoInput.Area id={`${id}-street`} placeholder="4116 Pretty View Lane" overflow="hidden" flex={1} value={field.value?.street} onChangeText={street => field.onChange({
              ...field.value,
              street
            })} onBlur={field.onBlur} disabled={disabled} ref={field.ref} data-sentry-element="BentoInput.Area" data-sentry-source-file="AddressField.tsx" />
            </BentoInput.Box>
            <FormError errorMessage={error?.street?.errorMessage} data-sentry-element="FormError" data-sentry-source-file="AddressField.tsx" />
          </BentoInput>
        </Fieldset>

        <Fieldset data-sentry-element="Fieldset" data-sentry-source-file="AddressField.tsx">
          <BentoInput theme={error?.zipCode ? "red" : "granted"} size={size || "$4"} data-sentry-element="BentoInput" data-sentry-source-file="AddressField.tsx">
            {label ? <BentoInput.Label htmlFor={`${id}-zip-code`}>
                US ZIP Code
              </BentoInput.Label> : null}
            <BentoInput.Box disabled={disabled} data-sentry-element="BentoInput.Box" data-sentry-source-file="AddressField.tsx">
              <BentoInput.Area id={`${id}-zip-code`} placeholder="12345" overflow="hidden" flex={1} value={field.value?.zipCode} onChangeText={zipCode => field.onChange({
              ...field.value,
              zipCode
            })} onBlur={field.onBlur} disabled={disabled} ref={field.ref} data-sentry-element="BentoInput.Area" data-sentry-source-file="AddressField.tsx" />
            </BentoInput.Box>
            <FormError errorMessage={error?.zipCode?.errorMessage} data-sentry-element="FormError" data-sentry-source-file="AddressField.tsx" />
          </BentoInput>
        </Fieldset>
      </XStack>
    </Fieldset>;
};